module.exports = __webpack_public_path__ + "daw.jpg?a598ebbc89986e6989e6b1d40fbbd3fe";